import { w } from './globals';

const SessionStorageIdKey = 'msameid';

export let id = guid();
try {
    const storage = w.sessionStorage;
    if (storage) {
        id = storage.getItem(SessionStorageIdKey) || guid();
        storage.setItem(SessionStorageIdKey, id);
    }
}
catch (e) {
    // setItem will throw a QuotaExceededError when iPad Safari is in private browsing.
    // We will ignore this and just always create a new ID in this case.
}

/**
 * Generate a new random GUID compliant with RFC4122 version 4
 */
export function guid(): string {
    // Stitch in '4' in the third group to comply with RFC4122 version 4
    return (term4() + term4() + '-' + term4() + '-4' + term4().substr(0, 3) + '-' + term4() + '-' + term4() + term4() + term4()).toLowerCase();

    function term4(): string {
        // tslint:disable-next-line:no-bitwise
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
}
